module.exports = __webpack_public_path__ + "static/media/lootbox-wavy-background.8d7be0a2.png";